// TODO: when we upgrade react-router, uncomment this code
// const createBrowserHistory = require('history').createBrowserHistory;
// const history = createBrowserHistory();
// export const browserHistory = history;
// export default history;

import { browserHistory as history } from 'react-router';

export default history;
